export default __webpack_public_path__ + "static/media/more-icon-white.3662c742.svg";